import React, { useCallback, useState } from "react";
import { pdfjs, Document, Page } from 'react-pdf';
import { highlightPattern } from '../../documentViewCore/highlightHelpers'

export default function ScrollSectionPagePaneDocumentView({ pdfData, pageNumber, setPageNumber, documentDimensions, onToggleZoom, docRendered, onDocRendered, executedQuery }) {
    const textRenderer = useCallback(
        (textItem) => highlightPattern(textItem.str, executedQuery),
        [executedQuery]
    );

    return (
        <div style={{ display: !docRendered ? 'none' : null }} onDoubleClick={onToggleZoom}>
            <Document file={pdfData} externalLinkTarget="_blank" loading='' onLoadSuccess={(args) => { setTimeout(() => onDocRendered(true), 500) }} onItemClick={({ dest, pageIndex, pageNumber }) => { setPageNumber(pageNumber) }}>
                <Page
                    loading=''
                    noData=''
                    pageNumber={pageNumber}
                    renderTextLayer={true}
                    height={documentDimensions.documentHeight}
                    width={documentDimensions.documentWidth}
                    renderAnnotationLayer={true}
                    customTextRenderer={textRenderer}
                />
            </Document>
        </div>
    );

}